import { render, staticRenderFns } from "./OrderSection.vue?vue&type=template&id=79634b9a&scoped=true&"
import script from "./OrderSection.vue?vue&type=script&lang=js&"
export * from "./OrderSection.vue?vue&type=script&lang=js&"
import style0 from "./OrderSection.vue?vue&type=style&index=0&id=79634b9a&scoped=true&lang=less&"
import style1 from "./fieldSettings.css?vue&type=style&index=1&id=79634b9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79634b9a",
  null
  
)

export default component.exports